module.exports = __webpack_public_path__ + "static/media/jesus.6ab22235.png";